import { render, staticRenderFns } from "./material-store.vue?vue&type=template&id=3ecc0eae&scoped=true&"
import script from "./material-store.vue?vue&type=script&lang=js&"
export * from "./material-store.vue?vue&type=script&lang=js&"
import style0 from "./material-store.vue?vue&type=style&index=0&id=3ecc0eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc0eae",
  null
  
)

export default component.exports